module.exports = __webpack_public_path__ + "img/lg_ring_r_l_null_0@3x.158c837c.png";